import React from 'react';
import usePage from '@monorepo/shared/src/hooks/use-page';
import { BaseHtmlRenderingProviders } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@legacy/HTMLRenderEngine';
import LetterBooksContent from '../LetterBook/components/LetterBookContent';

const StudentBook: React.FC = () => {
  const [{ noOfPages }] = usePage();

  return (
    <BaseHtmlRenderingProviders noOfPages={noOfPages} WordFeature={null}>
      <LetterBooksContent />
    </BaseHtmlRenderingProviders>
  );
};

export default StudentBook;
